import { State, Action, StateContext, Selector } from '@ngxs/store'
import { User } from '../models/user.model'
import { UserActions } from '../actions/user.actions'
import { Injectable } from '@angular/core'

export class UserStateModel {
    user: User
    static getDefaultUser(): User {
        return {id: 0, name: '', email: '', token: '', is_logged_in: false}
    }
}

@State<UserStateModel>({
    name: 'user',
    defaults: {
        user: UserStateModel.getDefaultUser()
    }
})
@Injectable()
export class UserState {
     
    @Selector()
    static getUser(state: UserStateModel) {
        return state.user
    }

    @Action(UserActions.Login)
    set({getState, setState}: StateContext<UserStateModel>, { payload }:UserActions.Login) {
        const state = getState()
        const newState = {user: {...state.user}}
        newState.user.id = payload.id
        newState.user.name = payload.name
        newState.user.email = payload.email
        newState.user.is_logged_in = true
        setState(newState)
    }

    @Action(UserActions.Logout)
    reset({setState}: StateContext<UserStateModel>, { }:UserActions.Logout) {
        setState({user: UserStateModel.getDefaultUser()})
    }

    @Action(UserActions.SetToken)
    set_user_token({getState, setState}: StateContext<UserStateModel>, { payload }:UserActions.SetToken) {              
        const state = getState()
        const newState = {user: {...state.user}}
        newState.user.token = payload.token
        setState(newState)
    }

}
